import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { list, reset } from '../../actions/client/list';
import { success } from '../../actions/client/delete';
import Create  from './Create';
import Update  from './Update';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import ListItem from './ListItem';
import { literals } from '../../languages';

class List extends Component {
  static propTypes = {
    error: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    deletedItem: PropTypes.object,
    list: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.setState({
      'createClientModal': false,
      'editClientModal': false,
      'editClientId': null,
      'activeProductPanelId' :null,
      'hideProductOptions': true,
    });

  }

  componentDidMount() {
    // console.log(this);
    // this.props.list(this.props.match.params.page && decodeURIComponent(this.props.match.params.page));
    this.props.list();
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.match.params.page !== nextProps.match.params.page) nextProps.list(nextProps.match.params.page && decodeURIComponent(nextProps.match.params.page));
  }

  componentWillUnmount() {
    this.props.reset();
  }

  toggleClientForm = () => {
    this.setState({
      'createClientModal': !this.state.createClientModal,
    });
  }

  toggleClientEditForm = (id) => {
    this.setState({
      'editClientModal': !this.state.editClientModal,
      'editClientId': id
    });
  }

  submitClientCallback = () => {
    this.setState({
      'createClientModal': false,
    }, ()=>{this.props.list()});
  }

  submitClientEditCallback = () => {
    this.setState({
      'editClientModal': false,
      'activeProductPanelId': null,
      'hideProductOptions': true
    }, ()=>{this.props.list();});
  }


  callbackToggleProductsPanel = (id)=> {
    this.setState({
      'activeProductPanelId': (this.state.activeProductPanelId !== id ? id : null),
      'hideProductOptions': (this.state.activeProductPanelId !== id ? false : true),
    });
  }


  render() {
    return <div>
      {/* <h1>Client List</h1> */}

      {this.props.loading && <div className="alert alert-info">{literals.loadingMessage[this.props.locale]}</div>}
      {this.props.deletedItem && <div className="alert alert-success">{literals.deleteSuccessMessage[this.props.locale]} </div>}
      {this.props.error && <div className="alert alert-danger">{this.props.error}</div>}

      {/* <p>
        <Link to="create" className="btn btn-primary">Create</Link>
      </p> */}
      <div>
        <Button color="btn btn-primary" onClick={this.toggleClientForm}>{literals.addNew[this.props.locale]}</Button>
          <Modal isOpen={this.state.createClientModal} fade={true} toggle={this.toggleClientForm} className={this.props.className}>
            <ModalHeader toggle={this.toggleClientForm}>{literals.clientInfo[this.props.locale]}</ModalHeader>
            <ModalBody>
              <Create locale={this.props.locale} submitCallback={this.submitClientCallback} />
            </ModalBody>
            {/* <ModalFooter>
              <Button color="primary" onClick={()=>{this.create.handleFormSubmit}}>Save</Button>{' '}
              <Button color="secondary" onClick={this.toggleClientForm}>Cancel</Button>
            </ModalFooter> */}
          </Modal>

          <Modal isOpen={this.state.editClientModal} fade={true} toggle={this.toggleClientEditForm} className={this.props.className}>
            <ModalHeader toggle={this.toggleClientEditForm}>{literals.clientInfo[this.props.locale]}</ModalHeader>
            <ModalBody>
              <Update locale={this.props.locale} submitCallback={this.submitClientEditCallback} retrieveClientProduct={this.props.retrieveClientProduct} id={this.state.editClientId} />
            </ModalBody>
            {/* <ModalFooter>
              <Button color="primary" onClick={()=>{this.create.handleFormSubmit}}>Save</Button>{' '}
              <Button color="secondary" onClick={this.toggleClientForm}>Cancel</Button>
            </ModalFooter> */}
          </Modal>
        </div>

      <div className="client-list">
        <div className="client-list__header">
          <div>{literals.name[this.props.locale]}</div>
          <div>{literals.domainName[this.props.locale]}</div>
          <div className="action-cell">{literals.actions[this.props.locale]}</div>
        </div>
        <div className="client-list__container">
          {this.props.data['hydra:member'] && this.props.data['hydra:member'].map(item =>
            <ListItem locale={this.props.locale} hideProductOptions={this.state.hideProductOptions} id={item['@id']} activeProductPanelId={this.state.activeProductPanelId} callbackToggleProductsPanel = {this.callbackToggleProductsPanel} key={`item${item['@id']}`} item={item} toggleClientEditForm={this.toggleClientEditForm} />
          )}
        </div>
      </div>

      {this.pagination()}
    </div>;
  }

  pagination() {
    const view = this.props.data['hydra:view'];
    if (!view) return;

    const {
      'hydra:previous': previous,
      'hydra:next': next,
      'hydra:last': last
    } = view;

    return <nav aria-label="Page navigation">

        <div onClick={()=>{this.props.list()}} className={`btn btn-default${previous ? '' : ' disabled'}`}><span aria-hidden="true">&lArr;</span> First</div>

        <div onClick={()=>{this.props.list(previous)}} className={`btn btn-default${previous ? '' : ' disabled'}`}><span aria-hidden="true">&larr;</span> Previous</div>

        <div onClick={()=>{this.props.list(next)}} className={`btn btn-default${next ? '' : ' disabled'}`}>Next <span aria-hidden="true">&rarr;</span></div>

        <div onClick={()=>{this.props.list(last)}} className={`btn btn-default${next ? '' : ' disabled'}`}>Last <span aria-hidden="true">&rArr;</span></div>

    </nav>;
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.client.list.data,
    error: state.client.list.error,
    loading: state.client.list.loading,
    deletedItem: state.client.del.deleted,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: (page) => dispatch(list(page)),
    reset: () => {
      dispatch(reset());
      dispatch(success(null));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);



// WEBPACK FOOTER //
// ./src/components/client/List.js